<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.profile.editProfile" small canGoBack></TopBarBg>
        <PageContent class="px-8" :marginTop="60" :rounded="true" :hasPoweredBy="false">
            <RegisterForm ref="form" :modalController="modalController" :editMode="false"></RegisterForm>
        </PageContent>
        <!-- <div class="fixed bottom-1 left-0 px-8 py-6 w-full bg-white">
            <VBtn blocked large variant="primary">{{ lbl.default.save }}</VBtn>
        </div>-->
        <div class="flex-none px-8 py-6">
            <VBtn blocked large variant="primary" @click="clickSave()">{{ lbl.default.save }}</VBtn>
        </div>
        <Footer :hasPoweredBy="false" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
        <BottomSheet
            ref="btsSuccess"
            v-model="bottomSheetSuccess"
            :persistent="false"
            @onClose="onCloseSuccess()"
        >
            <div class="px-6 -mt-10 text-center mb-8">
                <div class="mb-4">
                    <img src="@/assets/icon/dialog/success.svg" class="w-20 h-20 mx-auto" alt />
                </div>
                <div>
                    <div class="text-lg text-primary uppercase" v-html="lbl.profile.editSuccess"></div>
                </div>
            </div>

            <template #dismiss="{ on }">
                <button type="button" class="outline-none" v-on="on">
                    <img src="@/assets/icon/dialog/close.svg" alt />
                </button>
            </template>
            <Footer :hasPoweredBy="false" />
        </BottomSheet>
    </div>
</template>
<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import RegisterForm from "@/module/Register/component/RegisterForm.vue"
import VBtn from "@/components/Button/VBtn.vue"
import BottomSheet from "@/components/Dialog/BottomSheet.vue"

// mixin
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"
import ModalMixin from "@/mixin/ModalMixin"
import AuthPageMixin from "@/mixin/AuthPageMixin.js";

// helper

// service
import { RegisterModelBuilder } from "@/module/Register/model/RegisterModel"
import BzbsProfile from "@/core/Account/service/BzbsProfile"

export default {
    name: 'EditProfilePage',
    props: {},
    components: {
        TopBarBg,
        PageContent,
        Footer,
        RegisterForm,
        VBtn,
        BottomSheet
    },
    mixins: [LocaleMixin, ErrorApiMixin, ModalMixin, AuthPageMixin],
    emits: [],
    data: function () {
        return {
            formData: null,
            bottomSheetSuccess: false
        }
    },
    computed: {},
    methods: {
        onAccountInit: function () {
            this.setFormValues()
        },
        setFormValues: function () {
            let data = this.profile;
            // console.log(data)
            let builder = new RegisterModelBuilder()
            builder.setValuesFromUser(data)
            this.formData = builder.create()
            // console.log(this.formData)
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.form.setValues(this.formData)
                }, 100);
            })
        },
        clickSave: function () {
            /**@type {import("@/types/RegisterModel.d").RegisterModel} */
            let data = this.$refs.form.getData()
            // console.log(data)
            if (data != null) {
                // convert register model back to profile model
                let builder = new RegisterModelBuilder()
                let profileModel = builder.getUpdateModel(this.profile, data)

                this.modalController.loadingModal.show()
                this.sendUpdateProfile(profileModel).then((result) => {
                    this.modalController.loadingModal.hide()

                    if (result) {
                        this.getProfile().then(() => {
                            this.$refs.btsSuccess.show()
                            this.setFormValues()
                        })
                    }
                })
            }
        },
        sendUpdateProfile: function (profile) {
            return new Promise((resolve) => {
                BzbsProfile.updateProfile(profile, null, null, null, null).subscribe({
                    next: () => {
                        // console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err, true, { title: this.lbl.default.error })
                    },
                });
            });
        },
        getProfile: function () {
            return new Promise((resolve) => {
                BzbsProfile.getProfile().subscribe({
                    next: (data) => {
                        // console.log(data)
                        this.AccountStore.methods.setProfile(data.profile);
                        // this.AccountStore.methods.setAddress(data.address);
                        // this.AccountStore.methods.setShippingAddress(data.shippingAddress);
                        resolve();
                    },
                    error: (err) => {
                        resolve();
                        this.errorApi(err, true, { title: this.lbl.default.error })
                    }
                });
            });
        },

        onCloseSuccess: function () {
            this.$router.replace({
                name: "profile"
            })
        }
    }
}
</script>
